/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.attendance.period-rules'},
});

const PeriodRulesItem = () => (
  <RouteLinkItem
    route="midas/settings/attendance/attendance-period-rules"
    title={messages.title}
  />
);

export default PeriodRulesItem;
